import { Column, FormField, Grid, InputSelectField } from '@tempmee/react';
import { Controller, useFormContext } from 'react-hook-form';
import type { ISignUpFormValues } from '../../types';
import { TIME_PER_PATIENT_OPTIONS } from '../constants';
import { SectionHeading } from './SectionHeading';

const FIELDS = [
  { name: 'timePerPatient.rdh', label: 'Dental Hygienist:', dataCy: 'select-time-per-patient-rdh' },
  { name: 'timePerPatient.da', label: 'Dental Assistant:', dataCy: 'select-time-per-patient-da' },
  {
    name: 'timePerPatient.ddn',
    label: 'Associate Dentist:',
    dataCy: 'select-time-per-patient-ddn',
  },
] as const;

export const TimePerPatientSection = () => {
  const { control } = useFormContext<ISignUpFormValues>();

  return (
    <Column gap={0} style={{ marginTop: 4 }}>
      <SectionHeading>
        How Much Time Will Each Professional Spend With a Patient?
      </SectionHeading>
      <Grid columns={3} gap={3}>
        {FIELDS.map(({ name, label, dataCy }) => (
          <FormField key={name} label={label} htmlFor={name} labelWeight="normal">
            <Controller
              name={name}
              control={control}
              rules={{ required: true }}
              render={({ field, fieldState }) => (
                <div data-cy={dataCy}>
                  <InputSelectField<string>
                    options={TIME_PER_PATIENT_OPTIONS}
                    value={field.value}
                    onChange={field.onChange}
                    placeholder="Select"
                    isError={Boolean(fieldState.error)}
                  />
                </div>
              )}
            />
          </FormField>
        ))}
      </Grid>
    </Column>
  );
};
